import { InteractionType, EventSource, MixpanelEvent, ComponentType } from '../MixPanelTypes';

export type EngagementHubEvents =
  | 'ACTION_SELECTION'
  | 'ACTION_SET_AS_PRIMARY'
  | 'ACTION_SET_START_ONBOARDING'
  | 'ACTION_RESCIND_WORKDAY_DATA'
  | 'ACTION_DELETE_ENGAGEMENT'
  | 'ACTION_END_ENGAGEMENT'
  | 'EXPORT_ENGAGEMENT_RESULT'
  | 'VIEW_FULL_ENGAGEMENT';

export const engagementHub: Record<EngagementHubEvents, MixpanelEvent> = {
  EXPORT_ENGAGEMENT_RESULT: {
    eventDescription: 'Export Engagement Result',
    eventKey: 'export-engagement-result ',
    eventSource: EventSource.SERVER_EVENT,
    interactionType: InteractionType.N_A,
    componentType: ComponentType.N_A
  },
  ACTION_SELECTION: {
    eventKey: 'engagement-hub-action_selection',
    eventDescription: 'User selected action from the overflow menu',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.DIALOG_BUTTON
  },
  ACTION_END_ENGAGEMENT: {
    eventKey: 'end-engagement',
    eventDescription: 'End Engagement data action was successfully submitted',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.DIALOG_BUTTON
  },
  ACTION_DELETE_ENGAGEMENT: {
    eventKey: 'delete-engagement',
    eventDescription: 'Delete Engagement data action was successfully submitted',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.DIALOG_BUTTON
  },
  ACTION_RESCIND_WORKDAY_DATA: {
    eventKey: 'rescind-workday-data',
    eventDescription: 'Rescind Workday data action was successfully submitted',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.DIALOG_BUTTON
  },
  ACTION_SET_AS_PRIMARY: {
    eventKey: 'set-as-primary',
    eventDescription: 'Set as Primary action was successfully submitted',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.DIALOG_BUTTON
  },
  ACTION_SET_START_ONBOARDING: {
    eventKey: 'start-onboarding',
    eventDescription: 'Start Onboarding action was successfully submitted',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.DIALOG_BUTTON
  },
  VIEW_FULL_ENGAGEMENT: {
    eventKey: 'view-full-engagement',
    eventDescription: 'User clicked on view full engagement',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.INTERNAL_LINK_BUTTON
  }
} as const;
